<page-title [value]="'Workstations' | translate" />
<div class="row">
  <div class="col-12 col-md-8 mb-4">
    <h3 class="page-title" translate>Workstations</h3>
    <list-resource [controller]="controller">
      <checkbox
        *listResourceFilter
        listResourceFilterItem
        [text]="'IP Addresses' | translate"
        [ngModel]="showWorkstationIps"
        (ngModelChange)="toggleShowWorkstationIps()"
        data-test-qa="toggleShowWorkstationIps"
      />
      <checkbox
        *listResourceFilter
        listResourceFilterItem
        [text]="'Mounted workspaces' | translate"
        [ngModel]="showMountedWorkspaces"
        (ngModelChange)="toggleShowMountedWorkspaces()"
        data-test-qa="toggleShowMountedWorkspaces"
      />
      <with-pagination
        *extract="let data; from: controller; when: 'results'"
        [withoutFrozenUi]="data.refreshMetadata.stealthy"
      >
        <div class="list-group">
          @for (workstation of data.result.list.items; track workstation.id) {
            <a
              class="list-group-item list-group-item-action d-flex align-items-center"
              data-test-qa="workstation"
              [routerLink]="['/', 'workstation', workstation.id]"
            >
              @if (workstation.connectedUser != null) {
                <div class="row w-100">
                  <div class="col-md-6 d-flex align-items-center">
                    <i class="fas fa-fw fa-circle text-success me-3"></i>
                    <i class="far fa-fw fa-desktop ms-2"></i>
                    <div class="ms-2">
                      <strong data-test-qa="workstationDisplayName">
                        {{ workstation.displayName }}
                      </strong>
                      @if (showWorkstationIps) {
                        <div data-test-qa="workstationIps">
                          {{ workstation.ipAddresses }}
                        </div>
                      }
                      @if (showMountedWorkspaces) {
                        <div data-test-qa="mountedWorkspaces">
                          {{ workstation.workspaces }}
                        </div>
                      }
                    </div>
                  </div>
                  <div
                    class="col-md-6 mt-2 mt-md-0 d-flex align-items-center"
                    data-test-qa="connectedUsers"
                  >
                    <div class="ms-auto"></div>
                    <avatar class="me-3" [user]="workstation.connectedUser" size="sm" />
                    <div>{{ workstation.connectedUser.displayName }}</div>
                    @if (workstation.connectedUsersCount > 1) {
                      <strong class="ms-2">+ {{ workstation.connectedUsersCount - 1 }}</strong>
                    }
                  </div>
                </div>
              }
              @if (workstation.connectedUser == null) {
                <i class="fas fa-fw me-3"></i>
                <i class="far fa-fw fa-desktop ms-2"></i>
                <div class="ms-2">
                  <strong data-test-qa="workstationDisplayName">
                    {{ workstation.displayName }}
                  </strong>
                  @if (showWorkstationIps) {
                    <div>{{ workstation.ipAddresses }}</div>
                  }
                </div>
              }
            </a>
          }
        </div>
      </with-pagination>
    </list-resource>
  </div>
  <div class="col-12 col-md-4">
    <ng-container *extract="let data; from: controller; when: 'idle'">
      <spinner />
    </ng-container>
    <ng-container *extract="let data; from: controller; when: ['empty', 'no-results', 'results']">
      <div>
        <h3 class="page-title" translate>Connections</h3>
        <label class="mb-0" translate>Connected workstations</label>
        <h3 class="mt-0" data-test-qa="connectedWorkstations">
          {{ data.result.extra.connectedWorkstationsCount }}
        </h3>
        <label class="mb-0" translate>Connected users</label>
        <h3 class="mt-0">{{ data.result.extra.connectedUsersCount }}</h3>
        <h3 class="mt-4" translate>Workspace connections</h3>
        <div class="row">
          <div class="col">
            <label class="mb-0" translate>SMB</label>
            <h3 class="mt-0">{{ data.result.extra.smbMountedWorkspacesCount }}</h3>
          </div>
          <div class="col">
            <label class="mb-0" translate>AFP</label>
            <h3 class="mt-0">{{ data.result.extra.afpMountedWorkspacesCount }}</h3>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
